import { Alert, CircularProgress } from "@mui/material";
import React from "react";
import RichTextEditor from "../../organisms/RichTextEditor/RichTextEditor";
import Button from "../../atoms/Button/Button";
import { handleCopy } from "../../../services/helpers/commonHelpers";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Panel from "../../atoms/Panel/Panel";
import classNames from "classnames";
import AiReportCustomPrompt from "../AiReportCustomPrompt/AiReportCustomPrompt";

interface AiReportDialogProps {
  formattedReport?: string;
  aiReport?: string;
  setAiReport?: (value: string) => void;
}

const AiReportDialog = (props: AiReportDialogProps) => {
  const { formattedReport, aiReport, setAiReport } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isLoading = aiReport === "";

  const className = classNames("dui-ai-report-dialog", {
    "dui-ai-report-dialog-loading": isLoading,
  });

  return (
    <div className={className}>
      {!isLoading ? (
        <div
          className="dui-ai-report-dialog-wrapper"
          id="dui-ai-report-dialog-wrapper"
        >
          <div className="dui-ai-report-dialog-buttons">
            <div className="dui-ai-report-title">{t("generatedReport")}</div>
          </div>
          <div className="dui-ai-report-wrapper">
            <Alert
              severity="warning"
              className="dui-ai-report-dialog-alert dui-alert-warning"
            >
              {t("generatedWarning")}
            </Alert>
            <div className="dui-ai-report-generated">
              <div className="dui-ai-report">
                <div className="dui-ai-report-text">
                  <RichTextEditor
                    markdown={aiReport ?? ""}
                    allowTextSizeChange={false}
                    onChange={(value) => setAiReport?.(value)}
                  ></RichTextEditor>
                </div>
                <Button
                  onClick={() => handleCopy(dispatch, aiReport)}
                  className="dui-copy-button-generated"
                >
                  {t("copy")}
                </Button>
              </div>
            </div>
            <Panel title={t("originalReport")}>
              <div className="dui-ai-report">
                <div className="dui-ai-report-text">{formattedReport}</div>
                <Button
                  onClick={() => handleCopy(dispatch, formattedReport)}
                  className="dui-copy-button"
                >
                  {t("copy")}
                </Button>
              </div>
            </Panel>

            <AiReportCustomPrompt
              id="differentialDiagnosis"
              title={t("differentialDiagnosis")}
              prompt="Navrhni difrenciálnu diagnostiku pre tohto pacienta"
              formattedReport={formattedReport}
            />
            <AiReportCustomPrompt
              id="liecba"
              title={t("treatment")}
              prompt="Navrhni liečbu pre tohto pacienta"
              formattedReport={formattedReport}
            />
            <AiReportCustomPrompt
              id="mkch10"
              title={t("mkch10")}
              prompt="Odpovedaj stručne. Urči kód MKCH-10 podľa https://www.nczisk.sk/Standardy-v-zdravotnictve/Pages/MKCH-10-Revizia.aspx pre diagnózu: "
              withInput
              inputPlaceholder="Zadajte diagnózu"
            />
          </div>
        </div>
      ) : (
        <div className="dui-ai-report-loading">
          <div className="dui-ai-report-loading-title">
            {t("generatingReport")}
          </div>
          <div className="dui-ai-report-loading-progress">
            <CircularProgress />
            <div className="dui-ai-report-loading-progress-text">
              {t("pleaseWaitGeneratingReport")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AiReportDialog;
